//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'aggregate_search_shop',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};